import * as CL from '@design-system/component-library';
import { useLocation, useRouteLoaderData } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';
import { isInBrowser } from '../../common/utils/ssrUtils.js';
import { useProactiveChatTrigger } from './hooks/useProactiveChatTrigger.js';
import { GenesysService } from './types.js';
import { detectService } from './utils.js';
import type { PageResponse } from '../../generated/api/pageResponse.js';

import './ProactiveChatTrigger.scss';

export const ProactiveChatTrigger = () => {
  const { pathname } = useLocation();
  const pageData = useRouteLoaderData('public-path-root') as PageResponse | undefined;
  const isSalesPage = detectService(pathname, pageData?.siteStructureNodes) === GenesysService.SALES;

  const { isVisible, dismiss, openChat } = useProactiveChatTrigger({ isSalesPage, pathname });

  if (!isVisible || !isInBrowser()) {
    return null;
  }

  const nodePaths = pageData?.siteStructureNodes?.map(node => node.path) ?? [];
  const heading = nodePaths.includes('/kauppa')
    ? t.DWS8('Need help choosing the right device?')
    : nodePaths.includes('/liittymat')
      ? t.NRPK('Need help choosing a subscription?')
      : t.KFRW('Need help?');

  return (
    <CL.Card
      className="of-proactive-chat-trigger"
      heading={
        <div>
          <CL.Button
            className={`${dsClass.PADDING_0} ${dsClass.FLOAT_RIGHT}`}
            color="tertiary"
            size="s"
            aria-label={t.E1IS('Close chat invitation')}
            onClick={dismiss}
          >
            <CL.Icon aria-hidden="true" color="black" icon="close" size="xl" type="regular" />
          </CL.Button>
          <img
            className="of-proactive-chat-trigger__image"
            src="https://static.elisa.com/v2/image/2tqybbhjs47b/68fVtgzRI5IcH6BzUCUOyE/f7a98894ffcf794aec7ebb6bcebea06abd048fd5.jpg"
            alt={heading}
          />
        </div>
      }
      content={
        <div className={dsClass.TEXT_ALIGN_CENTER} role="dialog" aria-label={t.LO9Y('Chat with us')} aria-live="polite">
          <h3 className={dsClass.H3}>{heading}</h3>
          <CL.Button onClick={openChat}>{t.MOYY('Start chat')}</CL.Button>
        </div>
      }
      type="outlined"
    />
  );
};
